import React from "react";
import PropTypes from "prop-types";
import {Button, Checkbox} from "spectre-react/dist/cjs";
import ManualBonusBlock from "./ManualBonusBlock";
import withAbsenceRequestForm from "./withAbsenceRequestForm";
import {transformDayStatusToCSSClass} from "../shared";
import {createCalendarDayStatusOverride} from "../../../api";
import {DAY_STATUS} from "../../shared/constants";
import {
    addKeysToStatusChangesMapping,
    getAvailableButtons,
    getButtonVisibilityLevel,
    TIME_RANGE, VISIBILITY_LEVEL
} from "./shared";
import {SingleSelect} from "../../shared/select";
import {dmyFmt, isoFmt} from "../../shared/utils";


const statusLabels = {
    VACATION_PAID: 'Хочу в отпуск',
    VACATION_UNPAID: 'Хочу в отпуск за свой счет',
    TIME_OFF_PAID: 'Поставить отгул',
    TIME_OFF_UNPAID: 'Поставить отгул за свой счет',
    WORK_FROM_HOME: 'Работа из дома',
    WORK_FROM_HOME_NWD: 'Работа из дома в нер. день',
    WORK_FROM_OFFICE: 'Работа из офиса',
    WORK_FROM_OFFICE_NWD: 'Работа из офиса в нер. день',
    FIELD_WORK_HOME_CITY_NWD: 'Работа в СПб в нер. день',
    FIELD_WORK_OTHER_CITY_NWD: 'Работа в командировке в нер. день',
    ON_THE_ROAD: 'День в дороге',
    ON_THE_ROAD_NWD: 'День в дороге в нер. день',
    ILLNESS: 'Больничный',
};


const statusChangesMapping = addKeysToStatusChangesMapping({
    [DAY_STATUS.ILLNESS]: [],
    [DAY_STATUS.TIME_OFF_PAID]: [],  // нужно сначала удалить отпуск/отгул/больничный, чтобы день стал пустым, тогда можно будет изменить статус
    [DAY_STATUS.TIME_OFF_UNPAID]: [],
    [DAY_STATUS.TIME_OFF_PAID_PENDING]: [],  // сюда нельзя явно запихнуть кнопку "одобрить запрос", для этого есть отдельный блок
    [DAY_STATUS.TIME_OFF_UNPAID_PENDING]: [],
    [DAY_STATUS.VACATION_PAID]: [],
    [DAY_STATUS.VACATION_UNPAID]: [],
    [DAY_STATUS.VACATION_PAID_PENDING]: [],
    [DAY_STATUS.VACATION_UNPAID_PENDING]: [],
    [DAY_STATUS.WORK_FROM_HOME]: [
        {status: DAY_STATUS.ON_THE_ROAD, timeRange: TIME_RANGE.TODAY_PAST, selectionMode: undefined},
        {status: DAY_STATUS.WORK_FROM_HOME_NWD, timeRange: TIME_RANGE.TODAY_PAST, selectionMode: undefined},
        // {status: DAY_STATUS.WORK_FROM_OFFICE, timeRange: TIME_RANGE.TODAY_PAST, selectionMode: undefined},
        // {status: DAY_STATUS.WORK_FROM_OFFICE_NWD, timeRange: TIME_RANGE.TODAY_PAST, selectionMode: undefined}
    ],
    [DAY_STATUS.WORK_FROM_HOME_NWD]: [
        // {status: DAY_STATUS.WORK_FROM_OFFICE, timeRange: TIME_RANGE.TODAY_PAST, selectionMode: undefined},
        // {status: DAY_STATUS.WORK_FROM_OFFICE_NWD, timeRange: TIME_RANGE.TODAY_PAST, selectionMode: undefined}
    ],
    [DAY_STATUS.WORK_FROM_OFFICE]: [{
        status: DAY_STATUS.WORK_FROM_HOME, timeRange: TIME_RANGE.TODAY_PAST, selectionMode: undefined},
        {status: DAY_STATUS.WORK_FROM_HOME_NWD, timeRange: TIME_RANGE.TODAY_PAST, selectionMode: undefined}
    ],
    [DAY_STATUS.WORK_FROM_OFFICE_NWD]: [{
        status: DAY_STATUS.WORK_FROM_HOME, timeRange: TIME_RANGE.TODAY_PAST, selectionMode: undefined},
        {status: DAY_STATUS.WORK_FROM_HOME_NWD, timeRange: TIME_RANGE.TODAY_PAST, selectionMode: undefined}
    ],
    [DAY_STATUS.FIELD_WORK_HOME_CITY]: [
        {status: DAY_STATUS.FIELD_WORK_HOME_CITY_NWD, timeRange: TIME_RANGE.TODAY_PAST, selectionMode: undefined}
    ],
    [DAY_STATUS.FIELD_WORK_HOME_CITY_NWD]: [],
    [DAY_STATUS.FIELD_WORK_OTHER_CITY]: [
        {status: DAY_STATUS.FIELD_WORK_OTHER_CITY_NWD, timeRange: TIME_RANGE.TODAY_PAST, selectionMode: undefined}
    ],
    [DAY_STATUS.FIELD_WORK_OTHER_CITY_NWD]: [],
    [DAY_STATUS.EMPTY]: [
        {status: DAY_STATUS.WORK_FROM_HOME, timeRange: TIME_RANGE.TODAY_PAST, selectionMode: undefined},
        {status: DAY_STATUS.WORK_FROM_HOME_NWD, timeRange: TIME_RANGE.TODAY_PAST, selectionMode: undefined},
        {status: DAY_STATUS.WORK_FROM_OFFICE, timeRange: TIME_RANGE.TODAY_PAST, selectionMode: undefined},
        {status: DAY_STATUS.WORK_FROM_OFFICE_NWD, timeRange: TIME_RANGE.TODAY_PAST, selectionMode: undefined},
        {status: DAY_STATUS.ON_THE_ROAD, timeRange: TIME_RANGE.TODAY_PAST, selectionMode: undefined},
        {status: DAY_STATUS.ON_THE_ROAD_NWD, timeRange: TIME_RANGE.TODAY_PAST, selectionMode: undefined},
        {status: DAY_STATUS.TIME_OFF_PAID, timeRange: undefined, selectionMode: undefined},
        {status: DAY_STATUS.TIME_OFF_UNPAID, timeRange: undefined, selectionMode: undefined},
        {status: DAY_STATUS.VACATION_PAID, timeRange: TIME_RANGE.FUTURE, selectionMode: undefined},
        {status: DAY_STATUS.VACATION_UNPAID, timeRange: TIME_RANGE.FUTURE, selectionMode: undefined},
        {status: DAY_STATUS.ILLNESS, timeRange: undefined, selectionMode: undefined}
    ],
});



class ManagerActions extends React.PureComponent {
    static propTypes = {
        selectedDay: PropTypes.instanceOf(Date),
        selectedDayISO: PropTypes.string,
        selectedRange: PropTypes.arrayOf(PropTypes.instanceOf(Date)),
        selectedRangeISO: PropTypes.arrayOf(PropTypes.string),
        selectRange: PropTypes.bool,

        toggleSelectRange: PropTypes.func,
        availableStatuses: PropTypes.arrayOf(PropTypes.string),
        onItemCreated: PropTypes.func,

        selectedEngineer: PropTypes.object,
        selectEngineerItems: PropTypes.arrayOf(PropTypes.object),
        onEngineerChange: PropTypes.func,

        calendarType: PropTypes.oneOf(['YEAR', 'MONTH']),
        changeCalendarType: PropTypes.func,

        doOpenAbsenceRequestForm: PropTypes.func,

        onBonusAdded: PropTypes.func,
    }

    getAffectedDates() {
        const {selectRange, selectedRange, selectedDay} = this.props;

        return selectRange
            ? [isoFmt(selectedRange[0]), isoFmt(selectedRange[1])]
            : [isoFmt(selectedDay)];
    }

    setDayStatus = async (ev) => {
        const dayStatus = ev.target.parentElement.dataset.status;

        if (dayStatus === DAY_STATUS.VACATION_PAID || dayStatus === DAY_STATUS.VACATION_UNPAID ||
            dayStatus === DAY_STATUS.TIME_OFF_PAID || dayStatus === DAY_STATUS.TIME_OFF_UNPAID ||
            dayStatus === DAY_STATUS.ILLNESS
        ) {
            this.props.doOpenAbsenceRequestForm(dayStatus);
            return;
        }

        const affectedEngineerId = this.props.selectedEngineer._id;
        const affectedDates = this.getAffectedDates();

        const response = await createCalendarDayStatusOverride({
            affectedEngineerId: affectedEngineerId,
            affectedDates: affectedDates,
            dayStatus: dayStatus,
        });

        if (this.props.onItemCreated)
            this.props.onItemCreated(response);
    }

    changeCalendarViewMode = (ev) => this.props.changeCalendarType(ev.target.dataset.value);

    render() {
        const {timeline, selectedDay, selectedRange, selectRange, toggleSelectRange, calendarType} = this.props;
        const {selectedDayISO, selectedRangeISO} = this.props;
        const {selectEngineerItems, selectedEngineer, onEngineerChange, currentUser, onBonusAdded} = this.props;

        const timelineDay = timeline[isoFmt(selectedDay)];

        const isSelfSelected = selectedEngineer._id === currentUser._id;
        const availableButtons = getAvailableButtons(timeline, selectRange, selectedDay, selectedRange, statusChangesMapping, isSelfSelected);

        return (
            <div id="calendar-actions">
                <div className="form-group mt-2 mb-4">
                    <SingleSelect items={selectEngineerItems} name="selectedEngineer" clearable={false}
                                  selectedItem={selectedEngineer} onChange={onEngineerChange}
                    />
                </div>

                <div className="form-group mb-4">
                    <div className="btn-group btn-group-block">
                        <Button data-value="YEAR" active={calendarType === "YEAR"} onClick={this.changeCalendarViewMode}>Год</Button>
                        <Button data-value="MONTH" active={calendarType === "MONTH"} onClick={this.changeCalendarViewMode}>Месяц</Button>
                    </div>
                </div>

                <div className="form-group">
                    {!selectRange && <div>Выбран день {dmyFmt(selectedDay)}</div>}
                    {selectRange && <div>Выбран период {dmyFmt(selectedRange[0])} - {dmyFmt(selectedRange[1])}</div>}

                    <Checkbox id="selectRange" checked={selectRange} onChange={toggleSelectRange}>
                        Выбрать период
                    </Checkbox>
                </div>

                {availableButtons.map(({status, timeRange, selectionMode}) => {
                    const visibilityLevel = getButtonVisibilityLevel({status, timeRange, selectionMode}, selectRange, selectedRange, selectedDay);

                    if (visibilityLevel === VISIBILITY_LEVEL.HIDDEN) {
                        return null;
                    }

                    const isDisabled = visibilityLevel === VISIBILITY_LEVEL.DISABLED;

                    return (
                        <div key={status} data-status={status} className="form-group status-group">
                            <span className={transformDayStatusToCSSClass(status)}></span>
                            <Button block onClick={this.setDayStatus} disabled={isDisabled}>
                                {statusLabels[status]}
                            </Button>
                        </div>
                    );
                })}

                {timelineDay && (
                    <ManualBonusBlock engineerId={selectedEngineer._id}
                                  selectedRangeISO={selectRange ? selectedRangeISO : [selectedDayISO, selectedDayISO]}
                                  onSubmit={onBonusAdded}
                                  currentBonus={timelineDay.manualBonusPayAmount}
                    />
                )}
            </div>
        );
    }
}

export default withAbsenceRequestForm(ManagerActions);